/**
 * vue 过滤器
 * 过滤器备注方法名
 */

/**
 * vue 过滤器:uppercase
 * @param value 略
 */
export const uppercase = value => value.toUpperCase()

/**
 * vue 过滤器:lowercase
 * @param value 略
 */
export const lowercase = value => value.toLowerCase()

/**
 * vue 过滤器：money，精确到小数点两位
 * @param value 数值
 */
export const money = (value) => {
    const curVal = parseFloat(value || '0.00')
    const localV = curVal || 0.00
    return localV.toFixed(2)
}

/**
 * vue 过滤器：格式化信息统计，大于99显示‘99+’
 */
export const parseNum = (value) => {
    const num = Number(value)
    if (!num) {
        return value
    }
    let result = ''
    if (num) result = num.toString()
    if (num > 99) {
        result = '99+'
    }
    return result
}

export const parseLargeNum = (value) => {
    const num = parseFloat(value || '0.00')

    let result = ''
    if (num < 10000) {
        result = num.toFixed(2)
    } else {
        const minilize = parseFloat(num / 10000)
        result = `${minilize.toFixed(2)}万`
    }
    return result
}

/**
 * vue 过滤器：格式化信息统计，大于99显示‘...’
 */
export const parseNumPoint = (value) => {
    const num = Number(value)
    if (!num) {
        return value
    }
    let result = ''
    if (num) {
        result = num.toString()
    }
    if (num > 99) {
        result = '...'
    }
    return result
}

/**
 * 手机号分割 {ddd dddd dddd}
 */
export const sliceMobile = (value) => {
    if (!value) {
        return ''
    }

    return value.replace(/\s/g, '').replace(/(^\d{3}|\d{4})(?=\d)/g, '$1 ')
}

/**
 * vue 过滤器：格式化，超过规定字符...
 */
export const overLength = (value, len) => { // value值，len长度
    if (value && value.length > len) {
        return `${value.slice(0, len)}...`
    }
    return value
}

/**
 * vue 过滤器：distance，距离 转换  距离<1公里，显示单位为m 距离≥1公里，显示单位为km（千米）
 * @param value 数值
 */
export const distance = (value) => {
    let val = Number(value)
    let result = ''
    if (val < 1000) {
        result = `${parseInt(val)}米`
    } else {
        result = `${(val / 1000).toFixed(1)}公里`
    }
    return result
}

export const distance2 = (value) => {
    let val = Number(value)
    let result = ''
    if (val < 1000) {
        result = `${parseInt(val)}m`
    } else {
        result = `${(val / 1000).toFixed(1)}km`
    }
    return result
}

/**
 * 解决QQ中打开部分图片无法显示
 * @param {img}
 */
const imgHost  = value => {
    const imgStrArr = value.split('?')
    const httpHead = imgStrArr[0].split(':')
    let str = ''
    if (httpHead[0] === 'http') {
        str = imgStrArr[0].replace(/http/, 'https')
    } else {
        str = imgStrArr[0]
    }
    return str
}

/**
 * 截取字符串前八位
 * @param {value}
 */
export const toSubStr = (value) => {
    return value ? value.toString().substr(0, 8) : '请选择城市'
}

/**
 * vue 过滤器：格式化，重要的用户信息，只显示一个字，其余为***
 */
// export const userInfoSecrecy = (value) => { // value值
//     return value.replace(/([?<=.])./g, '*')
// }

/**
 * 手机号中间4位隐藏
 * @param {phone}
 */
const privacyPhone = phone => {
    let str = `${phone}`
    str = str.replace(str.substr(3, 4), '****')
    return str
}

/**
 * 整数去掉小数
 * @param {value}
 */
const recoveryInt = value => {
    return value.toString().replace(/\d+\.\d+/g, (val) => {
        if (Number(val) === parseInt(Number(val))) {
            return parseInt(Number(val))
        } else {
            return val
        }
    })
}

/**
 * 注册过滤器
 * @param Vue Vue
 */
function registFilters (Vue) {
    Vue.filter('uppercase', uppercase)
    Vue.filter('lowercase', lowercase)
    Vue.filter('money', money)
    Vue.filter('parseNum', parseNum)
    Vue.filter('parseNumPoint', parseNumPoint)
    Vue.filter('parseLargeNum', parseLargeNum)
    Vue.filter('sliceMobile', sliceMobile)
    Vue.filter('overLength', overLength)
    Vue.filter('distance', distance)
    Vue.filter('distance2', distance2)
    Vue.filter('imgHost', imgHost)
    Vue.filter('toSubStr', toSubStr)
    // Vue.filter('userInfoSecrecy', userInfoSecrecy)
    Vue.filter('privacyPhone', privacyPhone)
    Vue.filter('recoveryInt', recoveryInt)
}

export default registFilters
